import {getIdFromRelation} from '../modules/app/selectors';

import config from '../config';

let basePath = config.basePath || '/';

export {basePath};

export let parts = {
  base: 'dia',
  structure: 'structure',
  article: 'article',
  element: 'element',
  annotation: 'annotation',
  print: 'print',
  printqueue: 'queue',
  tags: 'tags'
};

export function homeRoute(lang) {
  return basePath + lang;
}

export function _baseRoute(lang) {
  return homeRoute(lang) + '/' + parts.base;
}

function _structuresRoute(lang) {
  return _baseRoute(lang) + '/' + parts.structure;
}

export function structuresRoute(lang) {
  return _structuresRoute(lang);
}

function _structureRoute(lang, id) {
  return _structuresRoute(lang) + '/' + id;
}

function _articlesRoute(lang, structureId) {
  return _structureRoute(lang, structureId) + '/' + parts.article;
}

function _articleRoute(lang, structureId, id) {
  return _articlesRoute(lang, structureId) + '/' + id;
}

function _elementsRoute(lang, structureId, articleId) {
  return _articleRoute(lang, structureId, articleId) + '/' + parts.element;
}

function _elementRoute(lang, structureId, articleId, id) {
  return _elementsRoute(lang, structureId, articleId) + '/' + id;
}

function _annotationsRoute(lang, structureId, articleId, elementId) {
  return _elementRoute(lang, structureId, articleId, elementId) + '/' + parts.annotation;
}

function _annotationRoute(lang, structureId, articleId, elementId, id) {
  return _annotationsRoute(lang, structureId, articleId, elementId) + '/' + id;
}

export let annotationFromStructure = function (params, elementId) {
  return articleRoute(params.articleId, params) + '/element/' + elementId + '/annotation';
};

export let annotationRoute = function (params, id) {
  return annotationFromStructure(params, params.elementId) + '/' + id;
};

export let structureIndexRoute = function (lang, id) {
  return _structureRoute(lang, id) + '/toc';
};

export let publicationRoute = function (params, id) {
  if (!params) {
    return null;
  }
  if (id) {
    return basePath + params.lang + '/dia/current/publication/' + id;
  }
  if (params.publicationId) {
    return basePath + params.lang + '/dia/current/publication/' + params.publicationId;
  }
  if (params.structureId) {
    return basePath + params.lang + '/dia/structure/' + params.structureId;
  }
  return null;
};

export let articleRoute = function (id, params) {
  return publicationRoute(params, params.publicationId) + '/article/' + id;
};

export let articleIndexRoute = function (lang, structureId, id) {
  return _articleRoute(lang, structureId, id) + '/articletext';
};

export let annotationsRoute = function (lang, structureId, articleId, elementId) {
  return _annotationsRoute(lang, structureId, articleId, elementId);
};

export let annotationIndexRoute = function (lang, structureId, articleId, elementId, id) {
  return _annotationRoute(lang, structureId, articleId, elementId, id);
};

export let tagIndexRoute = function (lang) {
  return diaBase(lang) + '/' + parts.tags;
};

export let diaBase = function (lang) {
  return basePath + lang + '/dia';
};

export let query = function (lang, query = '') {
  return homeRoute(lang) + query;
};

export let queryTagRoute = function(lang, tag) {
  return query(lang, '?tags=' + encodeURIComponent(tag));
};

export let urlFromType = function (lang, item) {
  let type;
  if (item.attributes.model_type) {
    type = item.attributes.model_type;
  }
  else {
    type = item.type;
  }
  switch (type) {
    case 'structure' :
      return structureIndexRoute(lang, item.id);
    case 'article' :
      return articleIndexRoute(lang, getIdFromRelation(item, 'structure'), item.id);
    case 'annotation':
      return annotationIndexRoute(lang, getIdFromRelation(item, 'structure'), getIdFromRelation(item, 'article'), getIdFromRelation(item, 'element'), item.id);
  }
};

export let printRoute = function (lang, ids = [], includes = []) {
  let route = _baseRoute(lang) + '/' + parts.print;
  let query = [];
  if (ids.length > 0) {
    query.push('selection=' + ids.join(','));
  }
  if (includes.length > 0) {
    query.push('include=' + includes.join(','));
  }
  query = query.join('&');
  if (query) {
    route += '?' + query;
  }
  return route;
};

export let printQueue = function (lang) {
  return _baseRoute(lang) + '/' + parts.print + '/' + parts.printqueue;
};



/** WEBPACK FOOTER **
 ** ./src/constants/public-routes.js
 **/